export const Translations = {
  en: {
    'Enter names below': 'Enter names below',
    Shuffle: 'Shuffle',
    Start: 'Start',
    Map: 'Map',
    Recording: 'Recording',
    'The winner is': 'The winner is',
    'Using skills': 'Using skills',
    'Buy me a coffee': 'Buy me a coffee',
    First: 'First',
    Last: 'Last',
    Multiple: 'Multiple',
    'Wheel of fortune': 'Wheel of fortune',
    BubblePop: 'BubblePop',
    'Pot of greed': 'Pot of greed',
    'Yoru ni Kakeru': 'Into The Night (by item4)',
    'Shake!': 'Shake!',
    'Input names separated by commas or line feed here': 'Input names separated by commas or line feed here',
    'This program is freeware and may be used freely anywhere, including in broadcasts and videos.':
      'This program is freeware and may be used freely anywhere, including in broadcasts and videos.',
    Close: 'Close',
    'The result has been copied': 'The result has been copied',
    'Default maps': 'Default maps',
    'Downloaded maps': 'Downloaded maps',
    'Get more maps': 'Get more maps',
    'Remove this map': 'Remove this map',
    'Remove this downloaded map?': 'Remove this downloaded map?',
    'Map installed': 'Map installed',
    'Map updated': 'Map updated',
    'This map is already installed': 'This map is already installed',
    'Failed to install the map': 'Failed to install the map',
    'You can keep up to 30 downloaded maps. Remove some maps first.':
      'You can keep up to 30 downloaded maps. Remove some maps first.',
    'Not enough storage. Remove some downloaded maps first.': 'Not enough storage. Remove some downloaded maps first.',
    'Cannot save maps in this browser': 'Cannot save maps in this browser',
    'Map Share': 'Map Share',
    Popular: 'Popular',
    Latest: 'Latest',
    'Most downloaded': 'Most downloaded',
    'My maps': 'My maps',
    'Search by title or author': 'Search by title or author',
    Install: 'Install',
    'Installing...': 'Installing...',
    Update: 'Update',
    Use: 'Use',
    'In use': 'In use',
    Remove: 'Remove',
    'Load more': 'Load more',
    'Loading...': 'Loading...',
    'Failed to load maps': 'Failed to load maps',
    Retry: 'Retry',
    'No maps found': 'No maps found',
    'No downloaded maps yet': 'No downloaded maps yet',
    'Update available': 'Update available',
    'No longer shared': 'No longer shared',
    Plays: 'Plays',
    Downloads: 'Downloads',
    'View on Map Share': 'View on Map Share',
    'Make a map': 'Make a map',
  },
  ko: {
    'Enter names below': '이름들을 입력하세요',
    Shuffle: '섞기',
    Start: '시작',
    Map: '맵',
    Recording: '녹화',
    'The winner is': '당첨 순위',
    'Using skills': '스킬 활성화',
    'Buy me a coffee': '개발자에게 커피 사주기',
    First: '첫번째',
    Last: '마지막',
    Multiple: '여러명',
    'Wheel of fortune': '운명의 수레바퀴',
    BubblePop: '버블팝',
    'Pot of greed': '욕망의 항아리',
    'Yoru ni Kakeru': '밤을 달리다 (by item4)',
    'Shake!': '흔들기!',
    'Input names separated by commas or line feed here': '이름들을 쉼표나 엔터로 구분해서 넣어주세요',
    'This program is freeware and may be used freely anywhere, including in broadcasts and videos.':
      '이 프로그램은 프리웨어이며 방송이나 영상 등을 포함한 어떤 용도로든 자유롭게 사용하는 것이 허용되어있습니다.',
    Close: '닫기',
    'The result has been copied': '결과가 복사되었습니다',
    'Default maps': '기본 맵',
    'Downloaded maps': '다운로드한 맵',
    'Get more maps': '맵 더 받기',
    'Remove this map': '이 맵 삭제',
    'Remove this downloaded map?': '다운로드한 이 맵을 삭제할까요?',
    'Map installed': '맵을 설치했습니다',
    'Map updated': '맵을 업데이트했습니다',
    'This map is already installed': '이미 설치된 맵입니다',
    'Failed to install the map': '맵을 설치하지 못했습니다',
    'You can keep up to 30 downloaded maps. Remove some maps first.':
      '다운로드한 맵은 30개까지 둘 수 있습니다. 먼저 쓰지 않는 맵을 삭제해 주세요.',
    'Not enough storage. Remove some downloaded maps first.': '저장 공간이 부족합니다. 쓰지 않는 맵을 삭제해 주세요.',
    'Cannot save maps in this browser': '이 브라우저에서는 맵을 저장할 수 없습니다',
    'Map Share': '맵 공유마당',
    Popular: '인기',
    Latest: '최신',
    'Most downloaded': '다운로드순',
    'My maps': '받은 맵',
    'Search by title or author': '제목이나 만든 사람으로 검색',
    Install: '설치',
    'Installing...': '받는 중...',
    Update: '업데이트',
    Use: '사용하기',
    'In use': '사용 중',
    Remove: '삭제',
    'Load more': '더 보기',
    'Loading...': '불러오는 중...',
    'Failed to load maps': '맵 목록을 불러오지 못했습니다',
    Retry: '다시 시도',
    'No maps found': '맵이 없습니다',
    'No downloaded maps yet': '아직 받은 맵이 없습니다',
    'Update available': '업데이트 있음',
    'No longer shared': '공유 중단됨',
    Plays: '플레이',
    Downloads: '다운로드',
    'View on Map Share': '공유마당에서 보기',
    'Make a map': '맵 만들기',
  },
} as const;

export type TranslatedLanguages = keyof typeof Translations;

export type TranslationKeys = keyof (typeof Translations)[TranslatedLanguages];
